import { type FC } from "react";
import { FeatureStatusLabel } from "@clientFrontend/features/scout/components/FeatureStatusLabel";
import { UserDetail } from "@clientFrontend/features/scout/components/UserDetail";
import { AlertTextPanel } from "@clientFrontend/features/scout/components/UserDetail/uiParts/AlertTextPanel";
import { type UserDetails } from "@clientFrontend/features/scout/types/userDetails";
import { ResultUserControlButton } from "@clientFrontend/features/scout/components/UserDetailContents/uiParts/ResultUserControlButton";
import type { UserHiddenButtonContent } from "@clientFrontend/features/scout/types/userHidden";
import * as styles from "./styles.css";

// 自由記述欄を畳む高さ
// 文字サイズが大きい場合
const MAX_DISPLAY_LARGE_TEXT_HEIGHT = 120;
// 文字サイズが小さい場合
const MAX_DISPLAY_SMALL_TEXT_HEIGHT = 60;

type Props = UserDetails & {
  userHiddenButtonContent?: UserHiddenButtonContent;
};

export const UserDetailContents: FC<Props> = ({
  labels,
  displayControlInformation,
  userData,
  historyInformation,
  hopedConditions,
  userProfileInformation,
  userHiddenButtonContent,
}) => {
  const showReadMoreButtonControlInformation = {
    showReadMoreButton: true,
    maxDisplayLargeTextHeight: MAX_DISPLAY_LARGE_TEXT_HEIGHT,
    maxDisplaySmallTextHeight: MAX_DISPLAY_SMALL_TEXT_HEIGHT,
  };
  return (
    <div className={styles.container}>
      <div className={styles.title}>{userData.sexAndAgeText}</div>
      {displayControlInformation.isHideInfo ? (
        <>
          {displayControlInformation.hideInfoReasonText &&
            displayControlInformation.scoutIndexUrl && (
              <AlertTextPanel
                reasonText={displayControlInformation.hideInfoReasonText}
                scoutIndexUrl={displayControlInformation.scoutIndexUrl}
              />
            )}
        </>
      ) : (
        <>
          {labels && (
            <div className={styles.labelsOuter}>
              {labels.map((label) => (
                <FeatureStatusLabel featureStatus={label} key={label}>
                  <span className={styles.label}>{label}</span>
                </FeatureStatusLabel>
              ))}
            </div>
          )}
          <UserDetail
            displayControlInformation={displayControlInformation}
            userData={userData}
            historyInformation={historyInformation}
            showReadMoreButtonControlInformation={showReadMoreButtonControlInformation}
            hopedConditions={hopedConditions}
            userProfileInformation={userProfileInformation}
          />
          {/* 求職者を非表示にする機能のボタン */}
          {userHiddenButtonContent?.isHidden !== undefined &&
            userHiddenButtonContent?.isLoading !== undefined && (
              <ResultUserControlButton
                isHidden={userHiddenButtonContent.isHidden}
                isLoading={userHiddenButtonContent.isLoading}
                onClickUserHiddenTrigger={() =>
                  userHiddenButtonContent.onClickUserHiddenTrigger
                    ? userHiddenButtonContent.onClickUserHiddenTrigger()
                    : undefined
                }
              />
            )}
        </>
      )}
    </div>
  );
};
